import React, { FC } from 'react';
import { LayoutPageHeading } from 'src/modules/layout';
import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { useLocale } from 'src/modules/locale';
import { PageEntity } from 'src/modules/pages';
import { LayoutDynamicZone } from 'src/modules/layout';

export interface ArticlesDownloadsPageProps {
  page: PageEntity;
}

const ArticlesDownloadsPage: FC<ArticlesDownloadsPageProps> = (props) => {
  const { intl, getLocalizedObject } = useLocale();

  if (!props?.page) return null;

  const { dynamic_content } = getLocalizedObject(props?.page);

  const meta_description = intl.formatMessage({
    id: 'page/magazinesAndBrochures/meta_description',
  });
  const title = intl.formatMessage({ id: 'page/magazinesAndBrochures/title' });
  const page_title = intl.formatMessage({ id: 'page/magazinesAndBrochures/page_title' });
  const subline = intl.formatMessage({ id: 'page/magazinesAndBrochures/subline' });

  const pageProperties = {
    title: page_title,
    description: meta_description,
    breadcrumbs: [
      {
        title: intl.formatMessage({ id: 'breadcrumbs/magazine' }),
        as: '/magazine',
        href: '/magazine',
      },
      {
        title,
        as: '/magazine/magazines-and-brochures',
        href: '/magazine/magazines-and-brochures',
      },
    ],
  };

  return (
    <LayoutPage {...pageProperties}>
      <LayoutPageHeading title={title} subline={subline} />
      <LayoutDynamicZone components={dynamic_content} />
    </LayoutPage>
  );
};

export default ArticlesDownloadsPage;
